
import { aspect } from "./aspect";
import { Categorie } from "../modelli-stampa.service";
import { environment } from "../../../environments/environment";
import { createGridConfig, gridSimple } from "./gridSettings/gridSettings";
import { AnaColumn } from "../forms-template.service";

//--------------- Registri C/S -------------------
export const RegistroRifiuti: AnaColumn[] = [
  {
    configuration:
    {

      titleGriglia: 'Configurazione registri di C/S Rifiuti',
      titleForm: 'Configurazione  Registri di C/S Rifiuti',

      helpDoc: 'ConfigurazioneRegistridiCSRifiut.html',

      service: 'registroRifiuti',
      api: 'RegistroRifiuti',
      filterList: '/',
      filterEditor: '/$',
      formType: 'simple',
      masterKey: 'id',
      nCol: 1,



    },
  },

  {
    itemType: "group", colCount: "2", caption: "", captionClass: 'd-none', colGroup: 5, groupDataField: "RegistroRifiuti", class: 'mt-3',
    data: [

      {
        type: 'campo',
        showInColumnChooser: true,
        allowHiding: false,
        colSpan: '2',
        nCol: 6,
        disableOnUpdate: false,
        dataField: "descrizione",
        dataType: "",
        caption: "Registro",
        maxLength: '45',
        // width: '100',
        // colWidth: 300,
        // maxSize: 45,
        validation: [{ type: "required", message: "Campo Obbligatorio" }],
      },
      {
        showInColumnChooser: true, allowHiding: false, type: 'campo',
        colVisible: true, dataField: 'sede_Descrizione', dataType: "",
        hideOnEdit: false, caption: "Unità Locale",
        // colWidth: '400',
        // width: '100%',
        disableOnUpdate: true,
        validation: [{ type: "required", message: "Campo Obbligatorio" }],
        editorType: 'dxSelectBox',
        nCol: 6,
        // colSpan: '2',
        dynamic: {
          dataSource: "Soggetto",
          service: 'soggetto',
          autocomplete: false,
          queryString: "?$filter=(nsAzienda eq true)",
          valueExpr: '',
          displayExpr: 'descrizione',
          // dataSource: 'Sede/GetSediNsAziende',
          // autocomplete: false,
          // service: '',
          // valueExpr: '',
          // queryString: '',
          filterStatic: '',
          // displayExpr: 'descrizioneSede',
          caption: "Elenco nostre unità produttive",
          filter: '',
          related: [
            'idSedeRentri|idSedeRentri',
            'id|idSede',
            'idSoggetto|idSoggetto',

          ],
          componentType: 'dynamicGrid',
          buttonOption: {
            text: 'Unità locali',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Sfoglia Unità Locali',
            name: 'ul',
            location: 'after',

          },
          settingGrid: createGridConfig(
            {
              // ...gridSimple,
              campoTabRif: '',
              masterKey: 'id',
              keyUnique: '',
              mode: 'cell',
              selectionMode: 'detail',
              rowAlternationEnabled: true,
              remoteOperations: true,
              allowUpdating: false,
              allowDeleting: false,
              allowAdding: false,
              searchAndSelect: true, //Cerca Valore e seleziona
              searchType: 'contains',
              height: 500,
              width: 600,
              showColBlank: true,
              toolbarButtonsBottomLeft: null,
              toolbarButtonsBottomRight: [0],
              isOdata: true,
              overrideDataSource: null,
              concatDataField: null,

              colonne: [
                {
                  dataField: 'ragioneSociale',
                  dataType: '',
                  caption: 'Azienda',

                  colSpan: '2', nCol: 10,
                  colWidth: '800',
                  hideOnEdit: false
                },

                // {
                //   dataField: 'descrizioneSede',
                //   dataType: '',
                //   caption: 'Unità Locale',
                //   hideOnEdit: false,
                //   colWidth: '700',
                // },

              ]
            }),
          detailOption: {
            costantValue: [
              { key: 'idSoggetto', value: 'id' }
            ],
            isEditable: false,
            isRemote: true,
            api: "Sede",
            service: 'sede',
            queryString: '/$idSoggetto',
            colonne: [
              {
                dataField: 'descrizione',
                dataType: '',
                caption: 'Descrizione',
                allowEditing: false,
                colVisible: true,
                colWidth: 'auto'

              },
              {
                dataField: 'indirizzo',
                dataType: '',
                caption: 'Indirizzo',
                allowEditing: false,
                colVisible: true,
                colWidth: 'auto'

              },
              {
                dataField: 'civico',
                dataType: '',
                caption: 'Civico',
                allowEditing: false,
                colVisible: true,
                colWidth: 'auto'

              },
              {
                dataField: 'comune',
                dataType: '',
                caption: 'Comune',
                allowEditing: false,
                colVisible: true,
                colWidth: 'auto'

              },
              {
                dataField: 'siglaProvincia',
                dataType: '',
                caption: 'Provincia',
                allowEditing: false,
                colVisible: true,
                colWidth: 'auto'

              },
            ]

          },


        },
      },
      {
        type: 'campo',
        dataField: "idSedeRentri",
        caption: "Allineamento U.L",
        dataType: "string",
        class: "opacity-100",
        nCol: 4,
        // colSpan: 2,
        maxSize: 30,
        showClearButton: false,
        disableOnUpdate: true,
        colVisible: false,
        disabled: true,
        labelWidth: 100,
      },

      // { type: 'empty', colVisible: true, dataField: "" },
      {
        type: 'campoButton',
        nCol: 4,
        dataField: "registroRentri",
        caption: "ID Rentri",
        dataType: "",
        // colWidth: '120px',
        // colSpan: '2',
        maxLength: '45',
        disabled: true,
        disableOnUpdate: true,
        showClearButton: true,
        // labelWidth: 151,
        // button: {
        //   icon: 'glyphicon mdi mdi-playlist-plus',
        //   name: 'AssociaRegistroRentri',
        //   location: 'after',
        //   text: 'Allinea',
        //   hint: 'Sfoglia Registro Rentri'
        // },
      },
      {
        type: 'simpleButton',
        colVisible: true,
        dataField: "allineaRegistro",
        class: '',
        caption: " ",
        button: {
          text: 'Registro Rentri',
          name: 'allineaRegistro',
          location: 'after',
          class: '',
          event: "allineaRegistroClick",
          hint: "Registro Rentri per unità locale",
          icon: 'iconRentri',
          outPutValue: false,

        }
      },

      // {
      //   type: 'campo',
      //   showInColumnChooser: false,
      //   defaultValue: 'S',
      //   colVisible: false,
      //   dataField: "assegnaProtocollo",
      //   colSpan: '2',
      //   nCol: 10,
      //   caption: "Assegna Protocolli",
      //   editorType: 'radioGroup',
      //   radioGroup: {
      //     dataSource: 'RadioAssegnaProtocolli',
      //     displayExpr: 'text',
      //     valueExpr: 'id',
      //     layout: 'horizontal',
      //     static: true,
      //     items: [
      //       { id: 'S', text: 'In Stampa' },
      //       { id: 'R', text: 'In Registrazione' }
      //     ]

      //   }
      // },
    ]
  },
  {
    itemType: "group", colCount: "2", caption: "", captionClass: 'd-none', colGroup: 10, groupDataField: "nonno", class: 'mt-3',
    data: []
  },
  {
    itemType: "group", colCount: "2", caption: "Indicare data e numero del protocollo stampato", captionClass: '', colGroup: 5, groupDataField: "stampaProtocolli",
    data: [

      {
        // colWidth: '95',
        nCol: 3,
        type: 'campo',
        //editorType: 'dxNumberBox',
        acceptOnlyCharacters: environment.CHARACTERS_NUMBER_INPUT,
        dataField: "numeroUltimoProtocollo",
        caption: "Ultimo Prot.",
        maxLength: '6'
      },
      {
        // colWidth: '95',
        nCol: 3,
        type: 'campo',
        visible: false,
        dataField: "numeroUltimoProtocollo",
        caption: "Ultimo Prot.",
        maxLength: '6'
      },
      // { type: 'empty', colVisible: true, dataField: "" },
      {
        type: 'campo',
        dataField: "dataUltimoProtocolloStampato",
        caption: "Data Ultimo Movimento",
        format: "dd/MM/yyyy",
        editorType: "dxDateBox",
        // colWidth: '120px',
        // labelWidth: 200,
        dataType: 'date',
        acceptOnlyCharacters: environment.CHARACTERS_DATE,
        maxLength: '15',
        maxSize: 15,
        nCol: 3,
        // helpText: 'inserendo tale data non potrai stampare movimenti con data inferiore o uguale'
      },
      { type: 'empty', colVisible: true, dataField: "" },
      {
        type: 'campo', colVisible: true, dataField: 'modelloDiStampa_Descrizione', dataType: "", hideOnEdit: false, caption: "Modello di Stampa",
        // colWidth: 260,
        colSpan: '2',
        nCol: 6,
        showClearButton: true,
        disableOnUpdate: true,
        labelWidth: 150,
        dynamic: {
          autocomplete: false,
          caption: 'Modelli',
          dataSource: "ModelloDiStampa",
          valueExpr: '',
          related: ['id|idModelloDiStampa'],
          componentType: 'dynamicGrid',
          displayExpr: 'nomeModello',
          filterStatic: `?$filter=idCategoriaModello in ${Categorie.REGISTRO_DI_CARICO_E_SCARICO_GLOBALI}`,
          buttonOption: {
            text: 'Modelli',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Sfoglia lista Modelli',
            name: 'Modelli',
            location: 'after',
          },
          settingGrid: createGridConfig({
            ...gridSimple,
            colonne: [
              {
                dataField: 'nomeModello',
                caption: 'Nome Modello',
                dataType: '',
                visible: true,
              },
              {
                dataField: 'idCategoriaModello',
                caption: 'Categoria Modello',
                dataType: '',
                visible: true,
                groupIndex: 0,
                lista: {
                  static: false,
                  dataSource: 'CategoriaModello',
                  valueExpr: 'id',
                  displayExpr: 'descrizione',
                }
              },


            ]
          })




        },
      },
    ]
  }
]

// export const registroRifiutiElenco: AnaColumn[] = [
//   {
//     itemType: "group", colCount: "2", colSpan: "2", data: [
//       {
//         type: 'campo', colVisible: true, disableOnUpdate: true, mask: "000000", dataField: "id", minLength: "6", maxLength: "6", dataType: "number", caption: "Codice",
//         validation: [
//           { type: "stringLength", min: "6", max: "6", message: "Campo Obbligatorio" },
//           { type: "required", message: "Campo Obbligatorio" }
//         ],
//       },
//       {
//         showInColumnChooser: true, allowHiding: false, colWidth: '100px',
//         type: 'campo', dataField: "descrizione", dataType: "", caption: "Descrizione Registrod", colVisible: true,
//         validation: [{ type: "required", message: "Campo Obbligatorio" }]
//       },
//       { type: 'campoData', dataField: "dataUltimoProtocolloStampato", colVisible: false, format: "dd/MM/yyyy", editorType: "dxDateBox", dataType: "datetime", caption: "Data Ultimo Protocollo Stampato", width: 17 * aspect, },

//       {
//         type: 'campo', dataField: "numeroUltimoProtocollo", colVisible: false, dataType: "", maxLength: "4", caption: "Numero Ultimo Protocollo",

//       },

//       {
//         type: 'campo', colVisible: false, dataField: "idModelloDiStampa", dataType: "", caption: "Modello di Stampa",
//         width: 5 * aspect,
//         validation: [{ type: "required", message: "Campo Obbligatorio" }],
//         lista: {
//           dataSource: 'modellodistampa',
//           displayExpr: 'descrizione',
//           valueExpr: 'id',
//           static: false
//         }
//       },

//       {
//         type: 'campoSpecial', dataField: 'assegnaProtocolloInRegistrazione', dataType: "boolean", editorType: 'dxCheckBox', caption: 'Protocollo in Registrazione', hideOnEdit: false,
//         colSpan: '2', nCol: 10, colVisible: false,
//         width: 2.5 * aspect,
//         checkBox: {
//           event: {
//             type: 'disabledItem', //Specifica cosa deve fare nel value se disabled checkBox se  fleggato disabiliterà il Field tipoAutomezzo
//             key: 'assegnaProtocolloInRegistrazione', //In quanto listaCarrozzerieAlboGestore
//             value: [
//               {
//                 optionName: 'disabled',
//                 value: 'false'
//               }
//             ]
//           },



//         }
//       },
//     ]
//   },
// ]